import { Component, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subscription, fromEvent, map, merge, of } from 'rxjs';

@Component({
  selector: 'app-no-internet',
  templateUrl: './no-internet.component.html',
  styleUrls: ['./no-internet.component.css']
})
export class NoInternetComponent {
  status: any;
  isButtonDisabled: boolean = false;
  networkStatus: boolean = false;
  networkStatus$: Subscription = Subscription.EMPTY;

  constructor(private router: Router, private toastrService: ToastrService) {
    this.checkNetworkStatus();
  }

  ngOnInit() {
    this.status = localStorage.getItem('status');
    console.log("status", this.status);
  }

  reloadPage() {
    const status = localStorage.getItem('status');
    if (status === 'true') {
      ;
      const url = '/accueil';
      window.location.href = url;
      this.toastrService.error("Connexion réseau Résolu");
    } else {
      this.router.navigate(['/no-internet']);
    }
  }

  checkNetworkStatus() {
    this.status = navigator.onLine ? 'true' : 'false';
    localStorage.setItem('status', this.status);

    window.addEventListener('online', () => {
      this.status = 'true';
      localStorage.setItem('status', 'true');
      history.pushState(null, '', '/');
      this.toastrService.success("Connexion réseau rétablie");
    });

    window.addEventListener('offline', () => {
      this.status = 'false';
      localStorage.setItem('status', 'false');
      this.toastrService.error("Connexion réseau perdue");
      this.router.navigate(['/no-internet']);
      history.pushState(null, '', '/no-internet');
    });
  }
    @HostListener('window:popstate', ['$event'])
    onPopState() {
      if (!navigator.onLine) {
        this.router.navigate(['/no-internet']);
      }
    }

  }


